module.exports = __webpack_public_path__ + "img/Pista_18.cb90a0be.png";